<template>
    <div>
        <es-exception v-if="!hasModule('PRSID:DWNLD:DOWNLOAD')"
            exceptionMessage="Sorry, you are not authorized to access this content." />
        <div class="document-container">
            <div class="columns">
                <div class="column is-three-quarters">
                    <div class="document" style="height:100%">
                        <div class="header">
                            <EsHeader>
                                <template #header>
                                    <div class="header-title">Download Options</div>
                                </template>
                            </EsHeader>
                        </div>
                        <div class="content">
                            <es-loader v-if="this.loading === true" />
                            <div v-else>
                                <es-form>
                                    <template #es-form-header>
                                        <div class="header-container">
                                            <div class="header-elements">
                                                <font-awesome-icon :icon="['fas', 'poll']" size="lg" />
                                            </div>
                                            <div class="header-elements">
                                                <label class="title is-size-6">
                                                    Match Status
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                    <template #es-form>
                                        <table class="table is-fullwidth">
                                            <thead>
                                                <th></th>
                                                <th class="column-header has-text-grey nowrap">Status</th>
                                                <th class="column-header has-text-grey nowrap">Submission Date</th>
                                                <th class="column-header has-text-grey nowrap">Downloadable Record Count
                                                </th>
                                                <th class="column-header has-text-grey nowrap">Total Record Count</th>
                                            </thead>
                                            <tbody
                                                v-if="search && recordGroupCategories.length && isDownloadTypesAllowed">
                                                <tr class="batch-category has-text-weight-bold"
                                                    v-for="(category, index) in recordGroupCategories" :key="index">
                                                    <td>
                                                        <input type="radio" v-model="transGroupCode" :value="category.code"
                                                            :aria-label="category.code">
                                                    </td>
                                                    <td class="text-align--left">
                                                        {{ category.group }}
                                                    </td>
                                                    <td class="text-align--left">
                                                        {{ formatDateTime(search.createdDate) }}
                                                    </td>
                                                    <td class="text-align--left">
                                                       {{ category.totalCount }}
                                                    </td>
                                                    <td class="text-align--left">
                                                        {{ search.recordCount }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <es-exception v-if="!recordGroupCategories.length || !isDownloadTypesAllowed"
                                            style="margin:2rem" exceptionMessage="No records are available for download." />
                                    </template>
                                </es-form>
                                <es-form v-if="recordGroupCategories.length || isDownloadTypesAllowed">
                                    <template #es-form-header>
                                        <div class="header-container">
                                            <div class="header-elements">
                                                <font-awesome-icon :icon="['fas', 'file-edit']" size="lg" />
                                            </div>
                                            <div class="header-elements">
                                                <h6 class="title">
                                                    Format
                                                </h6>
                                            </div>
                                        </div>
                                    </template>
                                    <template #es-form>
                                        <div class="row removeUnderline">
                                            <div class="field is-horizontal">
                                                <div class="field-label is-normal">
                                                    <label class="label">
                                                        Download Type
                                                    </label>
                                                </div>
                                                <div class="field-body">
                                                    <div class="field">
                                                        <div class="control">
                                                            <div class="buttons has-addons">
                                                                <button v-for="(option, index) in downloadFormOptions"
                                                                    :key="index" class="button no-radius"
                                                                    :class="{ 'selected-option': downloadOption === option }"
                                                                    @click="selectType('downloadOption', option)">
                                                                    {{ option }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <template v-if="downloadOption === 'Advanced'">
                                            <div class="row removeUnderline">
                                                <div class="field is-horizontal ">
                                                    <div class="field-label is-normal">
                                                        <label class="label">File Format</label>
                                                    </div>
                                                    <div class="field-body">
                                                        <div class="field">
                                                            <div class="control">
                                                                <div class="buttons has-addons">
                                                                    <div class="text-align">
                                                                        {{ personIdFileFormat }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row removeUnderline">
                                                <div class="field is-horizontal">
                                                    <div class="field-label is-normal">
                                                        <label class="label">Delimiter</label>
                                                    </div>
                                                    <div class="field-body">
                                                        <div class="field">
                                                            <div class="control">
                                                                <div class="buttons has-addons">
                                                                    <button v-for="(item, index) in delimiterOptions"
                                                                        :key="index" class="button no-radius"
                                                                        :class="{ 'selected-option': delimiter === item.option }"
                                                                        @click="selectType('delimiter', item.option)">
                                                                        {{ item.label }}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row removeUnderline">
                                                <div class="field is-horizontal">
                                                    <div class="field-label is-normal">
                                                        <label class="label">Qualifier</label>
                                                    </div>
                                                    <div class="field-body">
                                                        <div class="field">
                                                            <div class="control">
                                                                <div class="buttons has-addons">
                                                                    <button v-for="(item, index) in qualifierOptions"
                                                                        :key="index" class="button no-radius"
                                                                        :class="{ 'selected-option': qualifier === item.option }"
                                                                        @click="selectType('qualifier', item.option)">
                                                                        {{ item.label }}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row removeUnderline">
                                                <div class="field is-horizontal">
                                                    <div class="field-label is-normal">
                                                        <label class="label">Date Format</label>
                                                    </div>
                                                    <div class="field-body">
                                                        <div class="field">
                                                            <div class="control">
                                                                <div class="select is-half-width">
                                                                    <select class="input is-full-width"
                                                                        v-model="dateFormat"
                                                                        aria-label="Date Format">
                                                                        <option v-for="(item, index) in dateFormatOptions"
                                                                            :key="index" :value="item.option">
                                                                            {{ item.label }}
                                                                        </option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row removeUnderline">
                                                <div class="field is-horizontal">
                                                    <div class="field-label is-normal">
                                                        <label class="label">Include Header/Footer </label>
                                                    </div>
                                                    <div class="field-body">
                                                        <div class="field">
                                                            <div class="control">
                                                                <div class="buttons has-addons">
                                                                    <button
                                                                        v-for="(item, index) in includeHeaderFooterOptions"
                                                                        :key="index"
                                                                        class="button no-radius"
                                                                        :class="{ 'selected-option': includeHeaderFooter === item.option }"
                                                                        @click="selectType('includeHeaderFooter', item.option)">
                                                                        {{ item.label }}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </es-form>
                            </div>
                            <div class="es-actions" v-if="recordGroupCategories.length && isDownloadTypesAllowed">
                                <es-form-actions>
                                    <template #form-actions>
                                        <div class="bottom-content">
                                            <ul>
                                                <li>
                                                    <div class="list-content" style="padding-right:5rem">
                                                        <button class="button is-primary" @click="checkSelectedStatus()">
                                                            Generate Extract
                                                        </button>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </es-form-actions>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-one-quarter">
                    <div class="document" style="height:100%">
                        <div class="header">
                            <EsHeader>
                                <template #header>
                                    <div class="header-title">Download History</div>
                                </template>
                            </EsHeader>
                        </div>
                        <div class="content">
                            <es-loader v-if="this.loadingHistory === true" />
                            <div v-else>
                                <table class="table is-fullwidth">
                                    <thead>
                                        <th class="has-text-grey text-align--left">User ID</th>
                                        <th class="has-text-grey text-align--left">Download Date</th>
                                    </thead>
                                    <tbody>
                                        <tr class="form-row" v-for="(category, index) in history" :key="index">
                                            <td class="text-align--left">
                                                {{ category.userEmail }}
                                            </td>
                                            <td class="text-align--left">
                                                {{ formatDateTime(category.lastUpdateDate) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="document" v-if="showExtract">
                <div class="header">
                    <es-header>
                        <template #header>
                            <div class="header-title">Extract File (1)</div>
                        </template>
                    </es-header>
                </div>
                <div class="content">
                    <es-loader v-if="loadingExtract === true" />
                    <div class="table-wrapper" v-else>
                      <table class="table is-hoverable is-fullwidth">
                          <thead>
                              <tr>
                                  <th title="Extract Date">
                                      Extract Date
                                      <font-awesome-icon :icon="['fa', 'sort']" />
                                  </th>
                                  <th title="Location Info">
                                      Location Info
                                      <font-awesome-icon :icon="['fa', 'sort']" />
                                  </th>
                                  <th title="Record Count">
                                      Record Count
                                      <font-awesome-icon :icon="['fa', 'sort']" />
                                  </th>
                                  <th title="Extract Name">
                                      Extract Name
                                      <font-awesome-icon :icon="['fa', 'sort']" />
                                  </th>
                                  <th title="Extract Status">
                                      Extract Status
                                      <font-awesome-icon :icon="['fa', 'sort']" />
                                  </th>
                                  <th title="Actions">
                                    Actions
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>
                                      <div class="has-text-weight-bold">
                                          {{ formatExtractDate(extract.createdDate) }}
                                      </div>
                                      <div>
                                          <span class="padding-left--small has-text-grey">
                                              {{ formatExtractTime(extract.createdDate) }}
                                          </span>
                                      </div>
                                  </td>
                                  <td>
                                      <div class="is-flex flex-direction--column">
                                          <div v-if="search.pidSearchDistrictSchoolAssociation[0] != null">
                                              <router-link :to="{
                                                  name: 'PIDistrictInfoDetails',
                                                  params: { code: search.pidSearchDistrictSchoolAssociation[0].districtCode },
                                              }" class="has-text-weight-bold has-text-primary" style="font-size:14px">
                                                  {{ search.pidSearchDistrictSchoolAssociation[0].district.location.name }}
                                              </router-link>
                                              <span class="padding-left--small has-text-grey is-italic">
                                                  ({{ search.pidSearchDistrictSchoolAssociation[0].districtCode }})
                                              </span>
                                          </div>
                                          <div v-if="search.pidSearchDistrictSchoolAssociation[0] != null">
                                              <router-link :to="{
                                                  name: 'PISchoolInfoDetails',
                                                  params: {
                                                      districtCode: search.pidSearchDistrictSchoolAssociation[0].districtCode,
                                                      schoolCode: search.pidSearchDistrictSchoolAssociation[0].schoolCode,
                                                  },
                                              }" class="is-italic">
                                                  {{ search.pidSearchDistrictSchoolAssociation[0].school.location.name }}
                                              </router-link>
                                              <span class="padding-left--small has-text-grey is-italic">
                                                  ({{ search.pidSearchDistrictSchoolAssociation[0].schoolCode }})
                                              </span>
                                          </div>
                                      </div>
                                  </td>
                                  <td>
                                      <div class="has-text-weight-bold">
                                          {{ extract.totalCount ? extract.totalCount : "In progress" }} of {{ search.recordCount }}
                                      </div>
                                  </td>
                                  <td>
                                      <div>
                                          {{ extract.fileName }}
                                      </div>
                                  </td>
                                  <td>
                                      <div class="has-text-weight-bold">
                                          {{ statusName }}
                                      </div>
                                  </td>
                                  <td class="action">
                                      <div v-if="(statusId === 3)">
                                          <a v-if="extract.fileExtension" @click.prevent="downloadFile($event)"
                                              :href="buildSplitUrl(extractId)">
                                              Download
                                          </a>
                                      </div>
                                      <div v-else>
                                          <a @click="refreshExtract"
                                              @keypress="refreshExtract"
                                              role="link"
                                              tabindex="0"
                                          >
                                              Refresh
                                          </a>
                                      </div>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                </div>
            </div>
            <iframe ref="downloadFrame" title="Download - Extract File"></iframe>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faPoll,
    faFileEdit,
    faClock,
    faSyncAlt,
    faSort,
} from '@fortawesome/pro-solid-svg-icons';
import EsException from '@/components/EsException.vue';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import PermissionManager from '@/mixins/PermissionManager';
import EsFormActions from '@/components/EsFormActions.vue';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
    faPoll,
    faFileEdit,
    faClock,
    faSyncAlt,
    faSort,
);
export default {
    mixins: [
        FieldLabels,
        NotificationManager,
        PermissionManager,
    ],
    components: {
        EsForm,
        EsHeader,
        EsFormActions,
        EsLoader,
        EsException,
    },
    props: {
        search: {
            type: Object,
        },
    },
    data() {
        return this.initialData();
    },
    async created() {
        await this.onLoad();
    },
    watch: {
        transGroupCode() {
            this.nearMatchDetails();
        }
    },
    computed: {
        ...mapGetters('lookups', [
            'pidTransactionExtractStatuses',
            'pidExtractStatuses',
        ]),
        ...mapGetters('propertiesModule', [
            'properties',
        ]),
        allowedExtractDownloadTypes() {
            return this.$store.state.propertiesModule.properties['PERSON-EXTRACT_DOWNLOAD_TYPES_ALLOWED'];
        },
        isDownloadTypesAllowed() {
            if (this.allowedExtractDownloadTypes) {
                return this.allowedExtractDownloadTypes.includes(this.search.submissionTypeCode);
            }
        },
        formDataBody() {
            const formData = new FormData();
            formData.append('pidSearchId', this.search.id);
            formData.append('extractType', this.transGroupCode);
            formData.append('referrer', this.referrer);
            if (this.downloadOption === 'Advanced') {
                formData.append('delimiter', this.delimiter);
                formData.append('qualifier', this.qualifier);
                formData.append('dateFormat', this.dateFormat);
                formData.append('includeHeaderFooter', this.includeHeaderFooter);
            }
            return formData;
        },
        latestId() {
            if (this.history.length !== 0) {
                return this.history.reduce((a, b) => Number(a.id) > Number(b.id) ? a : b);
            }
            return null;
        },
        recordGroupCategories() {
            const tansactionGroups = this.allTransactionStatusGroup();
            const tranStatusGroups = JSON.parse(JSON.stringify(tansactionGroups));
            tranStatusGroups.forEach((code, outerIndex) => {
                const total = [];
                tranStatusGroups[outerIndex].list.forEach((s) => {
                    if (s.count) {
                        total.push(s.count);
                    }
                    tranStatusGroups[outerIndex].totalCount = total.reduce((a, b) => a + b, 0);
                });
            });
            return tranStatusGroups;
        },
    },
    methods: {
        ...mapActions('lookups', [
            'loadPidTransactionExtractStatuses',
            'loadPidExtractStatuses',
        ]),
        async onLoad() {
            this.loading = true;
            this.loadingError = false;
            try {
                await Promise.all([
                    this.loadPidExtractStatuses(),
                    this.loadPidTransactionExtractStatuses(),
                ]);
                this.allTransactionStatusGroup();
                await this.loadHistory();
                if (this.history.length !== (0 | null)) {
                    this.extractId = this.latestId.id;
                    this.getExtract();
                }
            } catch (error) {
                this.loadingError = true;
            } finally {
                this.loading = false;
            }
        },
        allTransactionStatusGroup() {
            this.transactionStatuses = this.pidTransactionExtractStatuses;
            const tranStatusGroups = JSON.parse(JSON.stringify(this.transactionStatuses));
            try {
                this.search.pidSearchTransStatusCountAssociation.forEach((tranStatus) => {
                    tranStatusGroups.forEach((group, outerIndex) => {
                        if (group.list.map(n => n.id).flat().includes(tranStatus.status)) {
                            tranStatusGroups[outerIndex].list.forEach((s, innerIndex) => {
                                if (s.id === tranStatus.status) {
                                    tranStatusGroups[outerIndex].list[innerIndex].count = tranStatus.statusCount;
                                    tranStatusGroups[outerIndex].showThisGroup = true;
                                }

                            });
                        }
                    });
                });
                // console.log(tranStatusGroups)
            } catch (error) {
                throw error;
            }
            return tranStatusGroups.filter(x => x.showThisGroup);
        },
        checkSelectedStatus() {
            if (this.transGroupCode === null) {
                this.showNotification('danger', [this.statusError]);
            } else {
                this.resetNotifications();
                this.generateExtract();
            }
        },
        downloadFile(evt) {
            this.$refs.downloadFrame.src = evt.target.href;
        },
        buildSplitUrl(dlFileId) {
            return `${axios.defaults.baseURL}personid/extracts/${dlFileId}/content`;
        },
        formatDateTime(value) {
            return moment(value).format('MM/DD/YYYY h:mmA');
        },
        formatExtractDate(value) {
            return moment(value).format('MM/DD/YYYY');
        },
        formatExtractTime(value) {
            return moment(value).format('h:mmA');
        },
        async loadHistory() {
            this.loadingHistory = true;
            try {
                const response = await axios.get('personid/extracts', {
                    params: {
                        pidBatchId: this.search.id,
                    },
                });
                this.history = response.data;
            } catch (error) {
                this.showNotification('danger', ['Error loading history']);
            } finally {
                this.loadingHistory = false;
            }
        },
        async getExtract() {
            try {
                this.loadingExtract = true;
                const response = await axios.get(`personid/extracts/${this.extractId}`);
                this.extract = response.data;
                this.findId = this.extract.extractStatusId;
                this.extractId = this.extract.id;
                this.getExtractStatus();
                this.showExtract = true;
            } catch (error) {
                this.showNotification('danger', ['Error getting extract record']);
            } finally {
                this.loadingExtract = false;
            }
        },
        async generateExtract() {
            try {
                this.showExtract = true;
                this.loadingExtract = true;
                this.resetNotifications();
                const response = await axios.post('personid/extracts', this.formDataBody);
                this.extract = response.data;
                this.findId = this.extract.extractStatusId;
                this.extractId = this.extract.id;
                this.getExtractStatus();
            } catch (error) {
                this.showExtract = false;
                this.showNotification('danger', ['Error generating extract']);
            } finally {
                this.loadingExtract = false;
            }
            window.scrollTo({
                top: window.innerHeight,
                behavior: "smooth"});
        },
        getExtractStatus() {
            this.extractStatuses = this.pidExtractStatuses;
            this.extractStatuses.forEach((id, outerIndex) => {
                if (this.extractStatuses[outerIndex].id === this.findId) {
                    this.statusName = this.extractStatuses[outerIndex].name;
                    this.statusId = this.extractStatuses[outerIndex].id;
                }
            });
        },
        nearMatchDetails() {
            if (this.transGroupCode === "IDNMD") {
                this.includeHeaderFooter = false;
                return true;
            }
            return false;
        },
        selectType(field, option) {
            if (field === 'downloadOption') {
                this.downloadOption = option;
            }
            if (field === 'dmatchFileFormat') {
                this.dmatchFileFormat = option;
            }
            if (field === 'delimiter') {
                this.delimiter = option;
            }
            if (field === 'qualifier') {
                this.qualifier = option;
            }
            if (field === 'includeHeaderFooter') {
                this.includeHeaderFooter = option;
            }
        },
        async refreshExtract() {
            await this.getExtract();
            await this.loadHistory();
        },
        resetNotifications() {
            this.$store.state.notifications.isActive = false;
            this.$store.state.notifications.notificationType = null;
        },
        initialData() {
            return {
                extract: [],
                extractId: null,
                extractStatuses: [],
                findId: null,
                lastDate: null,
                loading: false,
                loadingError: false,
                loadingHistory: false,
                loadingExtract: false,
                history: [],
                pidTransactionStatuses: [],
                showExtract: false,
                statusId: null,
                statusName: null,
                statusObject: [],
                statusError: 'No Status Selected',
                transactionStatuses: [],
                transactionStatusGroup: [],
                transGroupCode: null,
                referrer: 'SEARCHBYFILE',
                downloadFormOptions: ['Simple', 'Advanced'],
                downloadOption: 'Simple',
                personIdFileFormat: 'Version 3.0',
                personIdFileFormatOptions: ['Version 3.0', 'Version 2.1', 'Version 1.0'],
                delimiter: "09",
                delimiterOptions: [
                    { label: 'Tab', option: "09" },
                    { label: 'Comma', option: ',' },
                ],
                qualifier: null,
                qualifierOptions: [
                    { label: 'Double Quotes ( " )', option: '"' },
                    // We may need Single Quote back in the future.
                    // { label: "Single Quote ( ' )", option: "'" },
                    { label: 'None', option: null },
                ],
                includeHeaderFooter: true,
                includeHeaderFooterOptions: [
                    { label: 'Yes', option: true },
                    { label: 'No', option: false },
                ],
                dateFormat: 'MM/dd/yyyy',
                dateFormatOptions: [
                    { label: 'mm/dd/yyyy', option: 'MM/dd/yyyy' },
                    { label: 'ISO Format (YYYY-MM-DD)', option: 'YYYY-MM-dd' },
                    { label: 'mm/d/yyyy', option: 'MM/d/yyyy' },
                    { label: 'm/d/yyyy', option: 'M/d/yyyy' },
                    { label: 'm/dd/yyyy', option: 'M/dd/yyyy' },
                ],
            };
        },
    },
};
</script>

<style lang="sass" scoped>
    .margin-bottom
      margin-bottom: 1rem
    .sort-by
      padding-right: 18px
      position: relative
      color: #777
      text-decoration: none
      &:before, &:after
      border: 4px solid transparent
      content: ""
      display: block
      height: 0
      right: 5px
      top: 50%
      position: absolute
      width: 0
      &:before
        border-bottom-color: #999
        margin-top: -9px
        &:after
          border-top-color: #999
          margin-top: 1px
    .header-container
      margin-bottom: 1rem
    .no-radius
      border-radius: 0
      background-color: #F2F2F2
      font-weight: normal
    .selected-option
      background-color: #ccc
      font-weight: bold
    .fields-container
      margin-left: 30px
    .text-align--left
      text-align: left !important
    .column-header
      padding-left: 0px
    .text-align--right
      text-align: right !important
    .text-align--left
      text-align: left !important
    .table-wrapper
      overflow-x: auto
      white-space: nowrap
    @media screen and (max-width: 70em)
      .columns
        display: block
        .column
          width: 100%
  </style>
